export default "__VITE_ASSET__DyAceL86__"